import React from 'react';
import { Container } from 'react-bootstrap';
import { Text, View } from '@aws-amplify/ui-react';
import { MdArrowBackIosNew } from 'react-icons/md';
import { FiDownload } from 'react-icons/fi';
import ButtonCTA from '../ButtonCTA';
import './style.sass';
import Moment from 'react-moment';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as TYPES from '../../store/actions/actions.js';
const CustomTopbar = (props) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { name, finishedAt, quizType: quizTypeProp } = props;
  
  // Get quizType from Redux store to avoid stale data issues
  const quizFinishedState = useSelector((state) => state.finishUserQuiz.quizFinishedData);
  const quizType = quizFinishedState?.quiz?.type || quizTypeProp;
  return (
    <Container className="custom-topbar" fluid>
      <Container fluid>
        <View className="custom-topbar-view">
          <View className="view-child1">
            <MdArrowBackIosNew onClick={() => navigate('/quizzes')} />
          </View>
          <View className="view-child2">
            <Text fontWeight={600}>{name}</Text>
            <Text fontSize={10}>
              <Moment format="MMM DD, YYYY">{finishedAt}</Moment>
            </Text>
          </View>
          <View className="view-child3">
            {/* Schedule Consultation 按钮已移至 Dashboard 页面更靠下位置 */}
            <ButtonCTA
              className={'download-button'}
              label={'Download Score Report'}
              onClick={() => {
                console.log('quizType', quizType);
                if (quizType === 'HSPT') {
                  navigate('/hspt');
                } else {
                  dispatch({
                    type: TYPES.LOADER_TEXT,
                    data: 'Please wait we are preparing score report for you',
                  });
                  navigate('/printpdf');
                }
              }}
              padding="20px 25px"
              fontSize="16px"
              height="55px"
              white
              icon={<FiDownload />}
            />
          </View>
        </View>
      </Container>
    </Container>
  );
};

export default CustomTopbar;
